import { render, staticRenderFns } from "./LivesWidget.vue?vue&type=template&id=014932fe&scoped=true&"
import script from "./LivesWidget.vue?vue&type=script&lang=ts&"
export * from "./LivesWidget.vue?vue&type=script&lang=ts&"
import style0 from "./LivesWidget.vue?vue&type=style&index=0&id=014932fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014932fe",
  null
  
)

export default component.exports